import React from "react";
import { useParams } from "react-router-dom";
import InnerLayout from "../../../components/layouts/inner-layout";
import CreateEWayBill from "../../../components/sales-section/e-way-bills/create-e-way-bill";

const AddEWayBill = () => {
  const { id } = useParams();

  return (
    <InnerLayout backBtn={true} title="New e-Way Bill">
      <CreateEWayBill invoiceId={id} />
    </InnerLayout>
  );
};

export default AddEWayBill;
